import { formatValue } from './formatValue'
import { FileReadView } from './FileReadView'
import { GalleryReadView } from './GalleryReadView'
import { ReadValuePlaceholder } from './ReadValuePlaceholder'
import { RichTextReadView } from './RichTextReadView'
import type { FieldDefinition } from '../../../types'

/**
 * Router read-mode. Bogate typy delegują do dedykowanych ReadView; pozostałe
 * przechodzą przez {@link formatValue} + ReadValuePlaceholder.
 */
export function ReadValue({
  field, value, contractId,
}: { field: FieldDefinition; value: unknown; contractId?: number }) {
  switch (field.fieldType) {
    case 'RICH_TEXT': return <RichTextReadView value={value} />
    case 'FILE':      return <FileReadView field={field} value={value} contractId={contractId} />
    case 'GALLERY':   return <GalleryReadView field={field} value={value} contractId={contractId} />
    default:          return <ReadValuePlaceholder display={formatValue(field, value)} />
  }
}
